<template>
  <div
    :id="id"
    class="dai-selector"
    :class="{
      'lista-abierta': estaListaAbierta,
      desactivado: desactivado,
    }"
  >
    <input
      type="text"
      class="placeholder-selector"
      :placeholder="placeholderActual"
      @click="estaListaAbierta = !estaListaAbierta"
      :readonly="!buscador"
      v-model="texto_filtro"
    />

    <div class="lista" :class="{ 'no-checkboxes': !multiple }">
      <div
        class="item remove-seleccion"
        v-if="!multiple && seleccion.length > 0"
        @click="limpiarSeleccion()"
      >
        {{ texto_limpiar }}
      </div>

      <!--div class="item remove-seleccion" v-if="multiple">
        <button>{{ texto_limpiar }}</button>
        <button class="icono-cerrar" />
      </div-->

      <label
        class="item"
        v-for="(val, key) in listaReactiva"
        :key="`label_${id}_${key}`"
        :for="`check_${id}_${key}`"
        :class="{ selected: seleccion.includes(key) }"
        @click="
          () => {
            if (!multiple) {
              estaListaAbierta = false;
            }
          }
        "
      >
        <input
          type="checkbox"
          :id="`check_${id}_${key}`"
          :key="`check_${id}_${key}`"
          :value="val"
          v-model="seleccion"
        />
        {{ formato_items(val) }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    lista: {
      type: [Array, Object],
      required: true,
    },
    formato_items: {
      type: Function,
      default: (texto) => {
        return texto;
      },
    },
    placeholder: {
      type: String,
      default: "Seleccionar",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    buscador: {
      type: Boolean,
      default: false,
    },
    texto_limpiar: {
      type: String,
      default: "Limpiar",
    },
    order: {
      type: Function,
      default: (a, b) => {
        if (a[1] > b[1]) {
          return 1;
        }
        if (a[1] < b[1]) {
          return -1;
        }
        // a must be equal to b
        return 0;
      },
    },
    desactivado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      estaListaAbierta: false,
      seleccion: [],
      texto_filtro: "",
    };
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.estaListaAbierta) {
        this.clickFuera(e.target);
      }
    });
  },
  watch: {
    texto_filtro(newVal) {
      console.log(newVal !== "" ? newVal : "texto vacio");
    },
    seleccion(newVal) {
      if (!this.multiple && newVal.length > 1) {
        this.seleccion = [newVal.pop()];
        return;
      }
      this.$emit("alCambiar", [...this.seleccion]);
    },
    estaListaAbierta(_new) {
      this.$emit("toggleOpen", _new);
    },
  },
  computed: {
    listaReactiva() {
      let _lista = !Array.isArray(this.lista)
        ? Object.entries(this.lista)
        : this.lista;
      return _lista.sort();
    },
    placeholderActual() {
      if (this.seleccion.length == 0) {
        return this.placeholder;
      }
      const texto = this.formato_items(this.seleccion[0]);

      return this.seleccion.length > 1
        ? `${texto} | ${this.seleccion.length - 1}`
        : texto;
    },
  },
  methods: {
    clickFuera(target) {
      let elements = [],
        element = target,
        identificador = `${this.id} dai-selector lista-abierta`;

      while (element !== null) {
        elements.push(`${element.id} ${element.className}`);
        if (elements[elements.length - 1] === identificador) {
          // console.log("ESTÁ ADENTRO DEL SELECTOR");
          break;
        }
        element = element.parentElement;
      }

      if (!elements.includes(identificador)) {
        // console.log("CLICK FUERA");
        this.estaListaAbierta = false;
      }
    },
    addSeleccion(val) {
      if (
        !this.seleccion
          .map((i) => JSON.stringify(i))
          .includes(JSON.stringify(val))
      ) {
        if (this.multiple) {
          this.seleccion.push(val);
        } else {
          this.seleccion = [val];
        }
      }
    },
    addSeleccionPorFiltro(filtro) {
      this.seleccion = this.listaReactiva.filter(filtro);
    },
    removeSeleccion(id) {
      if (this.seleccion.includes(id)) {
        if (this.multiple) {
          this.seleccion = this.seleccion.filter((i) => i !== id);
        } else {
          this.seleccion = [];
        }
      }
    },
    limpiarSeleccion() {
      this.seleccion = [];
    },
    emitirCambio(_seleccion) {
      this.$emit("alCambiar", _seleccion);
    },
  },
};

function sortObjectByKeys(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((r, k) => ((r[k] = obj[k]), r), {});
}
</script>

<style lang="scss" scoped>
.dai-selector {
  color: #000;
  background-color: #fff;
  border: 1.5px solid #000;
  border-radius: 5px;
  transition-delay: 0.3s;
  height: 40px;

  &.lista-abierta {
    transition-delay: 0s;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .lista {
      max-height: calc(51vh - 75px);
      width: calc(100% + 2px);
      max-width: inherit;
      box-shadow: 0 3px 6px #00000029;
      border-style: solid;
      left: -1px;
    }
  }
  .placeholder-selector {
    width: 100%;
    height: 100%;
    margin-bottom: 0;
    border: 0 solid;
    overflow: hidden;
    text-overflow: ellipsis;
    background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z" /></svg>');
    background-repeat: no-repeat;
    background-position: calc(100% - 10px), 50%;
    background-size: 12px;
    padding-right: 22px;

    &:read-only {
      cursor: pointer;
    }
    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: inherit;
      opacity: 1; /* Firefox */
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: inherit;
    }
    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: inherit;
    }
  }
  .lista {
    max-height: 0;
    max-width: 0;
    background-color: inherit;
    color: inherit;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    position: relative;
    margin: 0;
    overflow-y: auto;
    transition: max-height 0.3s ease-in-out;
    border-color: inherit;
    border-width: 0 1.5px 1.5px;
    z-index: 99;
    //width: 100%;

    .remove-seleccion {
      background-color: inherit;
      font-weight: 600 !important;
      position: sticky;
      top: 0;
      box-shadow: 0 3px 6px #00000015;

      button {
        // padding: 0;
        &.icono-cerrar {
          font-size: 28px;
          font-weight: bold !important;
        }
      }
    }
    .item {
      cursor: pointer;
      padding: 5px 10px 5px 5px;
      display: flex;

      input[type="checkbox"] {
        height: 1.15rem;
        margin: 0 5px 0 0;
        border-radius: 5px;
        font-size: smaller;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: 1px solid inherit;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: 1.5em 1.5em;
        flex-grow: 0;
        border-color: inherit;

        &:checked {
          background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M186 340l-90-91-32 31 122 122 262-261-32-31z"/></svg>');
        }
      }
      &:hover {
        background-color: #ddd;

        input[type="checkbox"] {
          border-color: inherit;
        }
      }
    }
    &.no-checkboxes {
      .item {
        padding: 5px 10px;
        input[type="checkbox"] {
          display: none;
        }
      }
    }
  }

  &.desactivado {
    color: rgba(0, 0, 0, 0.2);
    border-color: rgba(0, 0, 0, 0.2);

    .placeholder-selector {
      background-image: none;
      &::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #c9c9c9;
        opacity: 1;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #c9c9c9;
      }

      &::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #c9c9c9;
      }
    }
  }
}
</style>
